<template>
  <div>
    <div :style="{ position: 'absolute' }">
      <div
        v-for="(item, index) of markStyleArray"
        v-if="item"
        :style="item"
        :key="index"
      >
        <div class="circle" :style="{ background: item.markColor }"></div>
        <div
          class="circleOutLine"
          :style="{ 'border-color': item.markColor }"
        ></div>
        <div
          class="bar"
          :style="
            (style = {
              height: item.barHeight + 'px',
              background:
                '-webkit-linear-gradient(bottom, ' +
                item.markColor +
                ', rgba(255,0,0,0.01))'
            })
          "
        ></div>
      </div>
    </div>
    <ul class="legend">
      <li v-for="(item, index) in legendConf" :key="index">
        <div
          class="color-box"
          :style="{ background: legendColor[index] }"
        ></div>
        <div class="text">
          {{
            item.max > 10000
              ? item.min / 10000 + "-" + item.max / 10000 + "万"
              : item.min + "-" + item.max
          }}
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: "HeatMark",
  props: [
    "polygonsArray",
    "heatMarkConfig",
    "heatMarkData",
    "legendConf",
    "mapData"
  ],
  data: function() {
    return {
      legendColor: ["#DA221A", "#FF852F", "#F5E047", "#6BF15c", "#34B7ED"]
    };
  },
  computed: {
    colorConfig: function() {
      if (this.heatMarkConfig && this.heatMarkConfig.colors)
        return this.heatMarkConfig.colors;
      return [
        {
          min: 80,
          max: 100,
          color: "#DA221A"
        },
        {
          min: 60,
          max: 80,
          color: "#FF852F"
        },
        {
          min: 50,
          max: 60,
          color: "#F5E047"
        },
        {
          min: 30,
          max: 50,
          color: "#6BF15c"
        },
        {
          min: 0,
          max: 30,
          color: "#34B7ED"
        }
      ];
    },
    minHeight: function() {
      // if (this.heatMarkConfig && this.heatMarkConfig.minHeight !== undefined)
      //   return this.heatMarkConfig.minHeight;
      // return 0;
      return this.legendConf[this.legendConf.length - 1].min;
    },
    maxHeight: function() {
      // if (this.heatMarkConfig && this.heatMarkConfig.maxHeight !== undefined)
      //   return this.heatMarkConfig.maxHeight;
      // return 100;
      return this.legendConf[0].max;
    },
    minValue: function() {
      // let min = Infinity;
      // Object.keys(this.heatMarkData).map(key => {
      //   if (key !== undefined) {
      //     min = min < this.heatMarkData[key] ? min : this.heatMarkData[key];
      //   }
      // });

      // return min;
      let min = Infinity;
      for (let i = 0; i < this.mapData.length; i++) {
        if (this.mapData[i].valueList[0] < min) {
          min = this.mapData[i].valueList[0];
        }
      }
      return min;
    },
    maxValue: function() {
      // let max = -Infinity;
      // Object.keys(this.heatMarkData).map(key => {
      //   if (key !== undefined) {
      //     max = max > this.heatMarkData[key] ? max : this.heatMarkData[key];
      //   }
      // });
      // return max;
      let max = -Infinity;
      for (let i = 0; i < this.mapData.length; i++) {
        if (this.mapData[i].valueList[0] > max) {
          max = this.mapData[i].valueList[0];
        }
      }
      return max;
    },
    markStyleArray: function() {
      if (this.polygonsArray === undefined) return [];
      return this.polygonsArray.map(item => {
        let v = "";
        for (let i = 0; i < this.mapData.length; i++) {
          if (item.adcode == this.mapData[i].code) {
            v = this.mapData[i].valueList[0];
            break;
          }
        }

        if (!v) return undefined;
        const color = this.getColorByValue(v);
        const height = this.getHeightByValue(v);
        const _item = {
          position: "absolute",
          left: item.geometryCenter[0] + "px",
          top: item.geometryCenter[1] - 10 + "px",
          pointerEvents: "none",
          markColor: color,
          barHeight: height
        };
        return _item;
      });
    }
  },
  methods: {
    getColorByValue: function(value) {
      let index = 0;
      this.legendConf.forEach((item, _index) => {
        if (value >= item.min && value < item.max) {
          index = _index;
        }
      });
      return this.legendColor[index];
    },
    getHeightByValue: function(value) {
      var maxbarHeight = 80;
      var minbarHeight = 20;
      return (value / this.maxValue) * maxbarHeight + minbarHeight;
      // return (
      //   (value * (this.maxHeight - this.minHeight)) /
      //     (this.maxValue - this.minValue) +
      //   this.minHeight
      // );
    }
  },
  beforeUpdate: function() {},
  mounted: function() {}
};
</script>
<style scoped lang="less">
.circle {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 0.2rem;
  height: 0.16rem;
  transform: translate(-50%, -50%);
  border-radius: 50%;
}
.circleOutLine {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 0.3rem;
  height: 0.24rem;
  transform: translate(-50%, -50%);
  border-radius: 50%;
  border-width: 1px;
  border-style: solid;
}
.bar {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 0.2rem;
  transform: translate(-50%, -100%);
  opacity: 0.9;
}
.legend {
  position: absolute;
  right: 0.24rem;
  bottom: 0.1rem;
}
.legend li {
  height: 0.26rem;
  color: @base-text-color;
}
.legend li .color-box {
  display: block;
  width: 0.12rem;
  height: 0.12rem;
  margin-top: 0.04rem;
  margin-right: 0.12rem;
  border-radius: 50%;
  background: #ccc;
}
.legend li > div {
  float: left;
}
</style>
